import "core-js/modules/es6.reflect.construct.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

var _dec, _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { WebUI } from "../../wui-core/src/index.js";
import omit from "omit.js";
var propTypes = {
  className: PropTypes.string,
  type: PropTypes.string
};
var defaultProps = {
  viewBox: "0 0 1024 1024",
  clsPrefix: 'u-svgicon'
};
var SvgIcon = (_dec = WebUI({
  name: "svgicon",
  defaultProps: defaultProps
}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(SvgIcon, _Component);

  var _super = _createSuper(SvgIcon);

  function SvgIcon() {
    _classCallCheck(this, SvgIcon);

    return _super.apply(this, arguments);
  }

  _createClass(SvgIcon, [{
    key: "render",
    value: function render() {
      var _this = this;

      var _this$props = this.props,
          className = _this$props.className,
          type = _this$props.type,
          Component = _this$props.component,
          viewBox = _this$props.viewBox,
          clsPrefix = _this$props.clsPrefix,
          children = _this$props.children;
      var classString = classNames(_defineProperty({}, "".concat(clsPrefix), true));

      var renderInnerNode = function renderInnerNode() {
        // component > type
        if (Component) {
          return /*#__PURE__*/React.createElement("i", omit(_this.props, ["clsPrefix", "component"]), /*#__PURE__*/React.createElement(Component, null, children));
        }

        return /*#__PURE__*/React.createElement("svg", {
          className: classNames(className, classString),
          "aria-hidden": "true",
          viewBox: viewBox
        }, /*#__PURE__*/React.createElement("use", {
          xlinkHref: "#uftype-".concat(type)
        }));
      };

      return renderInnerNode();
    }
  }]);

  return SvgIcon;
}(Component)) || _class);
;
SvgIcon.propTypes = propTypes;
export default SvgIcon;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-svgicon/src/SvgIcon.js